import { useData } from '@/components';
import { CSSProperties, useMemo } from 'react';

export const useProductImageStyle = () => {
  const { productCard } = useData();

  // TODO: find another way to handle this, we were concerend about the
  // performance of the code because we have to run the js for every single image and we are
  // not sure about the while loop

  //const [isDarkBackground, setIsDarkBackground] = useState(false);

  // useEffect(() => {
  //   if (typeof window === 'undefined') return;

  //   let el = document.querySelector('figure');
  //   if (!el || !(el instanceof HTMLElement)) return;

  //   let bg = getComputedStyle(el).backgroundColor;

  //   // We traverse upwards if the background is transparent
  //   while (
  //     (bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)') &&
  //     el.parentElement
  //   ) {
  //     el = el.parentElement;
  //     bg = getComputedStyle(el).backgroundColor;
  //   }

  //   const rgb = parseRGB(bg);
  //   if (rgb) {
  //     const [r, g, b] = rgb;
  //     const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  //     setIsDarkBackground(luminance < 128);
  //   }
  // }, []);

  const objectFit = productCard?.product_image_style || 'contain';

  const style = useMemo(() => {
    const baseStyle: CSSProperties = { objectFit };
    // if (!isDarkBackground) {
    //   baseStyle.mixBlendMode = 'multiply';
    // }
    return baseStyle;
  }, [objectFit]);

  return { style };
};
